import { Module, Mutation, Action } from "vuex-module-decorators";
import PaginationModule from "@/store/base-modules/PaginationModule";
import { RootState } from "@/store";
import { queryRequest, handlePaginationData } from "@/utils/request";
import {
  queryIntegralFlow,
  integralMonth,
  getUserIntegral,
  getReviewIntegral
} from "@/graphql/star-level.gql";
import { queryCouponPage } from "@/graphql/claim.gql";
import { queryDataDictionaryListLang } from "@/graphql/dictionary.gql";
import { formatByDate, getDateBefore36 } from "@/utils/common/date";
import type { PaginationDataState } from "@/types";

export interface OwnerWinningDetailState extends PaginationDataState {
  searchCondition: any;
}

@Module({ name: "OwnerWinningDetailModule", namespaced: true })
export default class OwnerWinningDetailModule
  extends PaginationModule<OwnerWinningDetailState, RootState>
  implements OwnerWinningDetailState {
  public listData: any[] = [];
  public searchCondition: any = {}; // 筛选条件
  public openFilterFlag: boolean = false; // 打开筛选模块
  public timeSumMap = {}; // 时间统计集合
  public filterData: any = []; // 筛选条件数据
  public userIntegral: any = {}; // 用户积分

  @Mutation
  setFilterDataMutation(data: any[]) {
    this.filterData = data || [];
  }
  @Mutation
  setUserIntegralMutation(data: any) {
    this.userIntegral = data || {};
  }
  @Mutation
  saveListDataMutation(data: any[]) {
    this.listData = data || [];
  }
  @Mutation
  addListDataMutation(data: any[] = []) {
    this.listData.push(...(data || []));
  }
  @Mutation
  setSearchConditionMutation({ key = "", value = "" } = {}) {
    if (!key && !value) {
      this.searchCondition = {};
    } else {
      this.searchCondition[key] = value;
    }
  }
  @Mutation
  setOpenFilterFlagMutation(data: boolean) {
    this.openFilterFlag = data ?? false;
  }
  @Mutation
  setTimeSumMapMutation({ key = "", value = "" } = {}) {
    if (!(key && value)) {
      this.timeSumMap = {};
    } else {
      this.timeSumMap[key] = value;
    }
  }

  @Action
  async queryListAction({ callback }) {
    const {
      state: {
        searchCondition,
        paginationData,
        paginationData: { pageNum, pageSize }
      },
      commit
    } = this.context;
    const [start, end] = getDateBefore36();
    let { data = [], totalCount } = handlePaginationData(
      await queryRequest({
        query: queryCouponPage,
        variables: {
          input: {
            startTime: searchCondition.startTime || formatByDate(start),
            endTime: searchCondition.endTime || formatByDate(end)
          },
          pageInput: { pageNum, pageSize }
        }
      })
    );
    data = await callback(data);
    commit(
      pageNum === 1 ? "saveListDataMutation" : "addListDataMutation",
      data
    );
    // 保存总数
    commit("savePaginationData", { ...paginationData, totalCount });
  }

  @Action
  async queryFilterDataAction() {
    const data = await queryRequest({
      query: queryDataDictionaryListLang,
      variables: {
        input: {
          ddCode: "INTEGRAL_SOURCE", // 积分筛选
          lang: window.i18n.locale
        }
      }
    });
    this.context.commit("setFilterDataMutation", data);
  }
  @Action
  async getUserIntegralAction() {
    const data = await queryRequest({
      query: getUserIntegral
    });
    const { code } = await queryRequest({
      query: getReviewIntegral
    });
    data.waitCheckScore = code;
    this.context.commit("setUserIntegralMutation", data);
  }

  @Action
  async queryIntegralMonthAction(variables: Object) {
    const data = await queryRequest({
      query: integralMonth,
      variables
    });
    data.forEach(o => {
      this.context.commit("setTimeSumMapMutation", {
        key: o.year + String(o.month).padStart(2, "0"),
        value: o
      });
    });
  }
}
